import { supabase } from './supabase';

const VAPID_PUBLIC_KEY = 'BA_iHb9iI5MlIes_n8Pw1z71vaDca21pFENoHZAhDTFQeiyBwqvDi9NoRrnf32uj3xY-WFI0ugDHhMMpBjiq6oM';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function subscribeToPush() {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.log('Push notifications not supported');
      return false;
    }

    // Bail before the permission prompt if no SW is registered. Mobile web is
    // PWA-disabled (see src/index.jsx managePwaRegistration) so navigator
    // .serviceWorker.ready would hang forever — burn permission for nothing.
    const existing = await navigator.serviceWorker.getRegistration();
    if (!existing) {
      console.log('Push: no service worker registered, skipping subscription');
      return false;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Push permission denied');
      return false;
    }

    const registration = await navigator.serviceWorker.ready;

    // Check if already subscribed
    let subscription = await registration.pushManager.getSubscription();

    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });
    }

    const subJson = subscription.toJSON();
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return false;

    // Save subscription to Supabase
    const { error } = await supabase.from('push_subscriptions').upsert({
      user_id: user.id,
      endpoint: subJson.endpoint,
      p256dh: subJson.keys.p256dh,
      auth: subJson.keys.auth,
    }, { onConflict: 'user_id,endpoint' });

    if (error) {
      console.error('Error saving push subscription:', error);
      return false;
    }

    // subscription saved
    return true;
  } catch (err) {
    console.error('Push subscription error:', err);
    return false;
  }
}

export async function unsubscribeFromPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
      // Remove from DB
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        await supabase.from('push_subscriptions').delete()
          .eq('user_id', user.id)
          .eq('endpoint', subscription.endpoint);
      }
    }
    return true;
  } catch (err) {
    console.error('Push unsubscribe error:', err);
    return false;
  }
}
